import React from "react";
import AjpPlannerEngine from "../components/ajp/AjpPlannerEngine";
import * as ajpPageRegistry from "../data/ajpPageRegistry";

const { getAjpPage } = ajpPageRegistry;

export default function AjpCityAirportRoutePage({ pageKey }) {
  return <AjpPlannerEngine page={getAjpPage(pageKey)} />;
}
